import { render, staticRenderFns } from "./TermTag.vue?vue&type=template&id=29a23f99"
import script from "./TermTag.vue?vue&type=script&lang=js"
export * from "./TermTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports